FAQSearchModel = require('../models/search')
FAQAutoCompleteItemView = require('./autocompleteItem')
Backbone = require 'backbone'
Backbone.$ = $
FaqAutosuggestionlistTemplate = require('../../autosuggestionlist.html.mustache')

class FAQAutoSuggestionListView extends Backbone.View
  @VIEWID = 3
  @VIEWNAME = "autosuggest"
  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.faq'
    @template = FaqAutosuggestionlistTemplate
    @breadCrumbView = @options.breadCrumbView
    @container = @options.container
    @spinner = @options.spinner
    @errorContainer = @options.errorContainer
    @searchModel = new FAQSearchModel()

  render : (searchText) ->
    @container.empty()
    @errorContainer.empty()
    @spinner.show()
    @getSuggestions(searchText)

  getSuggestions : (keyword) ->
    if @isValid(keyword)
      @searchModel.setUrl(keyword)
      @searchModel.fetch
        success: ( model, response, options ) =>
          stopTimer("t_fa")
          @spinner.hide()
          @renderSuggestions(response)
        error: ( model, xhr, options )  =>
          stopTimer("t_fa")
          @spinner.hide()
          @renderNoSuggestions(keyword, 'failure')
      startTimer("t_fa")


  isValid: (keyword) ->
    return  keyword? && keyword.length > 0

  renderBreadCrumbs: (keyword, text) ->
    leveldata =
      searchId : keyword
      text :  text
    @breadCrumbView.addCrumbs( leveldata )
    @breadCrumbView.render()

  renderSuggestionElements: (response) ->
    $autoSuggestionList = $("#suggestion-list", @$el)
    _.each(response.docs, (item, index) =>
      autoCompleteItem = new FAQAutoCompleteItemView()
      hash =
        item : item
        keyword : response.query
        index : index
      autoCompleteItem.render(hash)
      $autoSuggestionList.append(autoCompleteItem.el)
    )

  toHtml : (data = {}, template = @template) ->
    @$el.html toHtml(template, data , @I18nScope)
    @container.html(@el)

module.exports = FAQAutoSuggestionListView
